// Copyright (c) 2026 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";

import "./InfoScreen.scss";

interface IInfoScreenProps {
  title: React.ReactNode;
  // bottom button row
  footer?: React.ReactNode;
  // scroll the body within a height-limited container (SiteDetails)
  scrollable?: boolean;
  children?: React.ReactNode;
}

// shared "info card" layout (SiteDetails, UserInfo, ...): title, content and button row
const InfoScreen: React.FC<IInfoScreenProps> = ({ title, footer, scrollable, children }) => (
  <div className={`infoScreen${scrollable ? " infoScreenFill" : ""}`}>
    <div className="infoScreenBody">
      <h1>{title}</h1>
      <div className={scrollable ? "infoScreenScroll" : "infoScreenContent"}>
        {children}
        {footer && <div className="infoScreenFooter">{footer}</div>}
      </div>
    </div>
  </div>
);

export default InfoScreen;
